var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.popupContents),function(popup,index){return _c('div',{key:index},[_c('div',{domProps:{"innerHTML":_vm._s(popup.html)}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }